import React, { useEffect } from 'react';
import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useApp } from '../../AppContext';
import { emptyObject } from '../../lib/emptyObject';
import Loading from '../UI/atoms/Loading';

const allowedEmails = ['naman@earthlabs.com', 'amein@northernminergroup.com'];

export default function AdminWrapper() {
  const { user, isLoadingAuth, handleLoading } = useApp();
  const location = useLocation();

  useEffect(() => {
    handleLoading(false);
    // eslint-disable-next-line
  }, []);

  if (isLoadingAuth) {
    return <Loading />;
  }

  if (emptyObject(user)) {
    return <Navigate to='/login' state={{ from: location }} replace />;
  }

  const email = (user.email || '').toLowerCase();
  if (!allowedEmails.includes(email)) {
    return <Navigate to='/' replace />;
  }

  return <Outlet />;
}
